import { instance as axios } from '../http'
import {
  ENDPOINT_AUTH,
  ENDPOINT_USERDATA,
  ENDPOINT_EMAILRESET,
  ENDPOINT_FINISHRESETPASSWORD,
  ENDPOINT_USER_AUTHORITIES,
  ENDPOINT_CREATE_USER
} from '../endpoints'

const getAuth = payload => axios.post(ENDPOINT_AUTH, payload)
const getUserData = () => axios.get(ENDPOINT_USERDATA)
const getUserAuthorities = () => axios.get(ENDPOINT_USER_AUTHORITIES)
const setPassword = payload => axios.post(ENDPOINT_FINISHRESETPASSWORD, payload)
const setNewRequestPassword = payload => axios.post(ENDPOINT_EMAILRESET, payload)
const createUser = payload => axios.post(ENDPOINT_CREATE_USER, payload)

export default {
  getAuth,
  getUserData,
  setPassword,
  setNewRequestPassword,
  getUserAuthorities,
  createUser
}



// WEBPACK FOOTER //
// ./src/repository/api/user.js